(function() {
  if (window.__bricksFansKlaviyoMetaAdvancedMatching) return;
  window.__bricksFansKlaviyoMetaAdvancedMatching = true;

  var PIXEL_ID = '870652901993604';
  var STORAGE_KEY = 'bricks_fans_meta_user_hashes';
  var STORAGE_TTL_MS = 180 * 24 * 60 * 60 * 1000;

  function canTrack() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy) return true;
      if (typeof privacy.analyticsProcessingAllowed === 'function' && !privacy.analyticsProcessingAllowed()) return false;
      if (typeof privacy.marketingAllowed === 'function' && !privacy.marketingAllowed()) return false;
      return true;
    } catch (error) {
      return false;
    }
  }

  function normalizeEmail(value) {
    return String(value || '').trim().toLowerCase();
  }

  function normalizePhone(value) {
    return String(value || '').replace(/[^0-9]/g, '');
  }

  function isSha256(value) {
    return /^[a-f0-9]{64}$/.test(String(value || ''));
  }

  function toHex(buffer) {
    return Array.prototype.map.call(new Uint8Array(buffer), function(byte) {
      return byte.toString(16).padStart(2, '0');
    }).join('');
  }

  function sha256(value) {
    if (!value || !window.crypto || !window.crypto.subtle || !window.TextEncoder) return Promise.resolve('');
    return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(value)).then(toHex).catch(function() {
      return '';
    });
  }

  function readStoredHashes() {
    try {
      var stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}');
      if (!stored.updatedAt || Date.now() - stored.updatedAt > STORAGE_TTL_MS) return {};
      var userData = {};
      if (isSha256(stored.em)) userData.em = stored.em;
      if (isSha256(stored.ph)) userData.ph = stored.ph;
      return userData;
    } catch (error) {
      return {};
    }
  }

  function storeHashes(userData) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
        em: userData.em || '',
        ph: userData.ph || '',
        updatedAt: Date.now()
      }));
    } catch (error) {}
  }

  function ensureFbq(userData) {
    !function(f,b,e,v,n,t,s){
      if(f.fbq)return;
      n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;
      n.push=n;
      n.loaded=!0;
      n.version='2.0';
      n.queue=[];
      t=b.createElement(e);
      t.async=!0;
      t.src=v;
      s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

    window.fbq('init', PIXEL_ID, userData || {});
  }

  function eventId(prefix) {
    return 'bf_' + prefix + '_' + Date.now() + '_' + Math.random().toString(36).slice(2, 12);
  }

  function publishShopifyEvent(userData, detail) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('bricks_fans:klaviyo_lead_identified', {
          em: userData.em || '',
          ph: userData.ph || '',
          formId: detail.formId || detail.formID || '',
          companyId: detail.companyId || '',
          source: 'klaviyo_form'
        });
      }
    } catch (error) {}
  }

  function trackLead(userData, detail) {
    if (!canTrack() || !Object.keys(userData).length) return;
    ensureFbq(userData);
    var formId = detail.formId || detail.formID || '';
    window.fbq('trackSingle', PIXEL_ID, 'Lead', {
      content_name: 'Klaviyo coupon popup',
      content_category: 'newsletter_signup',
      source: 'klaviyo_form',
      form_id: formId,
      value: 0,
      currency: 'EUR'
    }, { eventID: eventId('klaviyo_lead') });

    window.fbq('trackSingle', PIXEL_ID, 'PageView', {
      source: 'klaviyo_identity_sync',
      page_title: document.title,
      page_location: window.location.href
    }, { eventID: eventId('identity_pageview') });
  }

  function syncStoredIdentityToPageView() {
    if (!canTrack()) return;
    var userData = readStoredHashes();
    if (!Object.keys(userData).length) return;
    ensureFbq(userData);
    window.fbq('trackSingle', PIXEL_ID, 'PageView', {
      source: 'klaviyo_stored_identity',
      page_title: document.title,
      page_location: window.location.href
    }, { eventID: eventId('stored_identity_pageview') });
  }

  window.addEventListener('klaviyoForms', function(event) {
    var detail = event && event.detail ? event.detail : {};
    if (detail.type !== 'submit' && detail.type !== 'stepSubmit') return;
    if (!canTrack()) return;

    var metaData = detail.metaData || {};
    var email = normalizeEmail(metaData.email || metaData.Email || metaData.email_address);
    var phone = normalizePhone(metaData.phone_number || metaData.phone || metaData.Phone || metaData.telefone || metaData.Telefone);

    Promise.all([sha256(email), sha256(phone)]).then(function(results) {
      var userData = {};
      if (isSha256(results[0])) userData.em = results[0];
      if (isSha256(results[1])) userData.ph = results[1];
      if (!Object.keys(userData).length) return;
      storeHashes(userData);
      publishShopifyEvent(userData, detail);
      trackLead(userData, detail);
    });
  });

  syncStoredIdentityToPageView();
})();
